/* global axios */
import ApiClient from '../ApiClient';

class WgptBotsAPI extends ApiClient {
  constructor() {
    super('bots', { accountScoped: true, wgpt: true });
  }

  deleteAvatar(botId) {
    return axios.delete(`${this.url}/${botId}/avatar`);
  }

  search({ botId, ...params }) {
    return axios.get(`${this.url}/${botId}/search_chunks`, {
      params,
    });
  }

  getTemplates() {
    return axios.get(`${this.url}/templates`);
  }

  getRelativeIds(botId) {
    return axios.get(`${this.url}/${botId}/relative_ids`);
  }

  clone(botId) {
    return axios.post(`${this.url}/${botId}/clone`);
  }

  async export(botId) {
    const { data, headers } = await axios.get(`${this.url}/${botId}/export`, {
      responseType: 'blob',
    });

    let filename = 'bot_export.wgpt';
    const contentDisposition = headers['content-disposition'];
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(
        /filename\*=UTF-8''([^;]+)/i
      );
      if (filenameMatch) {
        filename = decodeURIComponent(filenameMatch[1]);
      }
    }

    const file = new File([data], filename, { type: 'application/zip' });
    return { data: file };
  }

  import(data) {
    return axios.post(`${this.url}/import`, data);
  }
}

export default new WgptBotsAPI();
